var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as actions from '../constants/actionTypes';
var orderItems = handleActions((_a = {},
    _a[actions.getOrderItems.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return payload;
    },
    _a[actions.getOrderItems.type.FAILED] = function () { return []; },
    _a), []);
var customerAddress = handleActions((_b = {},
    _b[actions.getOrderItems.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return ({
            name: payload[0].name,
            phone: payload[0].phone,
            email: payload[0].email,
            street: payload[0].street,
            unit: payload[0].unit,
            city: payload[0].city,
            state: payload[0].state,
            zipCode: payload[0].zipCode,
            latitude: payload[0].latitude,
            longitude: payload[0].longitude,
        });
    },
    _b), {});
var rmsInput = handleActions((_c = {},
    _c[actions.storeItemsToReturn.type.REQUEST] = function (state, _a) {
        var payload = _a.payload;
        if (!state) {
            return state;
        }
        return __assign(__assign({}, state), payload);
    },
    _c[actions.getOrderItems.type.SUCCESS] = function () { return ({}); },
    _c), {});
export default combineReducers({
    orderItems: orderItems,
    customerAddress: customerAddress,
    rmsInput: rmsInput,
});
//# sourceMappingURL=orders.js.map